import Tools from './tools';

export default class Nav {
  constructor() {
    // Nav

    this.toggleMenu();
    this.mobileDropdown();
  }

  toggleMenu() {
    const btn = document.querySelector('nav .container .burger');
    if (btn) {
      btn.addEventListener('click', () => {
        document.querySelector('nav').classList.toggle('open');
      });
    }
  }

  mobileDropdown() {
    if(window.innerWidth < 1025) {
      const elts = document.querySelectorAll('.menu-item-has-children');
      if(elts.length > 0) {
        elts.forEach((elt) => {
          if(elt.querySelector('& > a')) {
            elt.querySelector('& > a').addEventListener('click', (e) => {
              e.preventDefault();
              elt.classList.toggle('js-open');
            });
          }
        });
      }
    }
  }
}